// extracted by mini-css-extract-plugin
export default {"card":"CardDefault_card__uDeBR","icon":"CardDefault_icon__IQocd","head":"CardDefault_head__04bGS","body":"CardDefault_body__x6ty7","description":"CardDefault_description__gKTrC"};